package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.core.spotify.di.spotifyModule
import org.koin.core.KoinApplication
import org.koin.core.context.startKoin
import org.koin.core.module.Module
import org.koin.dsl.KoinAppDeclaration

/**
 * Coloque aqui SOMENTE módulos que existem no commonMain.
 * (módulos androidMain / iosMain / jsMain entram via extraModules)
 */
fun commonModules(): List<Module> = listOf(
    loginModule,
    networkModule,
    sessionModule,
    platformModule,
    appStartModule,
    dashboardModule,
    gamesModule,
    playersModule,
    matchesModule,
    expansionsModule,
    activeMatchModule,
    activeMatchUiModule,
    spotifyModule,
    statsModule,
    clanModule,
)
typealias KoinAppDeclaration = KoinApplication.() -> Unit

/**
 * Inicializa o Koin com:
 * - módulos comuns (commonMain)
 * - módulos extras (ex.: androidMain)
 */
fun initKoin(
    extraModules: List<Module> = emptyList(),
    appDeclaration: KoinAppDeclaration = {}
): KoinApplication {
    return startKoin {
        appDeclaration()
        modules(commonModules() + extraModules)
    }
}

